import createModel from './createModel';

export default {
    createModel,
};
